import React from 'react';

import {
  Typography,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  Section,
  TableCell,
  IconButton,
  DeleteIcon,
} from '@gogame/components';

import { useDeleteSharedAccount } from '../../data';

const SharedAccounts = ({ id, data, onShare }) => {
  const [deleteSharedAccount] = useDeleteSharedAccount();
  const isEmpty = !data?.length;
  return (
    <Section
      title={`Shared accounts (${data.length})`}
      isCollapsable={!isEmpty}
      initialOpen={false}
      action={
        <IconButton
          add
          tooltip={'Share Lookalike Audience'}
          onClick={onShare}
          data-cy-action={'add-shared-account'}
        />
      }
      subTitle={isEmpty ? 'No shared accounts' : true}
    >
      {data.length ? (
        <TableContainer>
          <Table width={'100%'}>
            <TableBody>
              {data.map((item) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell col={'name'} size={'small'}>
                      <Typography variant={'inherit'} display={'block'}>
                        {item.name}
                      </Typography>
                      <Typography variant={'caption'} color={'textSecondary'}>
                        #{item.id}
                      </Typography>
                    </TableCell>
                    <TableCell
                      col={'action'}
                      align={'right'}
                      padding={'actions'}
                    >
                      <IconButton
                        icon={<DeleteIcon />}
                        tooltip={'Remove account'}
                        onClick={() =>
                          deleteSharedAccount({
                            ...item,
                            lookalikeAudience: id,
                          })
                        }
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </Section>
  );
};

export default SharedAccounts;
